// FLAGS: none
// Works out where a session sits in the window in which "Autofill with AI" can still read its transcript.
import { differenceInMinutes, parseISO } from "date-fns";
import { ResponseConsultsConsultWithNotesResponse } from "@src/api/v1/data-contracts";

export const EXPIRING_SOON_MINUTES = 3 * 60;

export type AutofillAvailability =
  | { state: "available" | "expiring"; deadline: Date }
  | { state: "expired" }
  | { state: "none" };

type AutofillConsult = Pick<
  ResponseConsultsConsultWithNotesResponse,
  "transcriptAvailableUntil" | "transcriptionDeletedOn"
>;

/**
 * The API sends the earliest moment the transcript can be deleted, and when it was deleted. `transcriptGone` is
 * true when the summary request came back 404. A session with neither date never had a transcript, so it is "none".
 */
const getAutofillAvailability = (
  { transcriptAvailableUntil, transcriptionDeletedOn }: AutofillConsult,
  now: Date,
  transcriptGone = false,
): AutofillAvailability => {
  if (transcriptGone || transcriptionDeletedOn) return { state: "expired" };
  if (!transcriptAvailableUntil) return { state: "none" };

  const deadline = parseISO(transcriptAvailableUntil);
  const minutesLeft = differenceInMinutes(deadline, now);
  if (minutesLeft <= 0) return { state: "expired" };

  return {
    state: minutesLeft <= EXPIRING_SOON_MINUTES ? "expiring" : "available",
    deadline,
  };
};

export default getAutofillAvailability;
